import script from "./SameColorBallsSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./SameColorBallsSelector.vue?vue&type=script&setup=true&lang=ts"

import "./SameColorBallsSelector.vue?vue&type=style&index=0&id=5d98e4b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d98e4b0"]])

export default __exports__